export const TREND_CHARTS = [
  { key: "af", title: "AF Episodes", durationKey: "afDuration" },
  { key: "af_burden", title: "AF Burden" },
  { key: "vt", title: "VT Episodes", durationKey: "vtDuration" },
  { key: "nsvt", title: "NSVT Episodes", durationKey: "nsvtDuration" },
  { key: "raThreshold", title: "RA Capture Threshold" },
  { key: "raSensing", title: "RA Sense Threshold" },
  { key: "raImpedance", title: "RA Lead Impedance" },
  { key: "rvThreshold", title: "RV Capture Threshold" },
  { key: "rvSensing", title: "RV Sense Threshold" },
  { key: "rvImpedance", title: "RV Lead Impedance" },
  { key: "lvThreshold", title: "LV Capture Threshold" },
  { key: "lvSensing", title: "LV Sense Threshold" },
  { key: "lvImpedance", title: "LV Lead Impedance" },
  { key: "batteryLongevity", title: "Battery Longevity (Months)" },
  { key: "hvImpedance", title: "High Voltage Impedance" },
  { key: "pvcBurden", title: "PVC Burden" },
];
